<template>
  <div class="change-avatar">
    <div
      class="text-center"
      style="margin-bottom: 10px;"
    >
      <XImage
        alt="User Avatar"
        :src="imgDataUrl"
        width="300"
        height="300"
      />
    </div>
    <a
      class="btn btn-primary"
      @click="toggleShow"
    >{{ $t('label.uploadYourAvatar') }}</a>
    <my-upload
      v-model="show"
      field="avatar"
      :width="300"
      :lang-type="langType"
      :height="300"
      :url="`${apiUrl}/api/auth/backend/change-avatar`"
      :params="params"
      :headers="headers"
      img-format="png"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
    />
  </div>
</template>

<script>
import 'babel-polyfill'
import myUpload from 'vue-image-crop-upload'
import { mapState } from 'vuex'
import XImage from '@/components/XImage'

export default {
  name: 'ChangeAvatar',
  components: {
    XImage,
    'my-upload': myUpload
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_API,
      show: false,
      params: {
        user_id: null,
        name: 'avatar'
      },
      headers: null,
      imgDataUrl: '/img/avatar.png'
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.data
    }),
    langType () {
      return this.$i18n.locale
    }
  },
  mounted () {
    this.headers = {
      Authorization: 'Bearer ' + localStorage.getItem(this.$token),
      Accept: 'application/json'
    }
    if (this.user) {
      const { avatar } = this.user
      if (avatar) {
        this.imgDataUrl = `${this.baseUrl}/${avatar}`
      }
    }
  },
  methods: {
    toggleShow () {
      this.show = !this.show
    },
    cropSuccess (imgDataUrl, field) {
    },
    cropUploadSuccess (jsonData) {
      this.$store.dispatch('user/setUser', { user: jsonData.data })
      const { avatar } = jsonData.data
      this.imgDataUrl = `${this.apiUrl}/${avatar}`
    },
    cropUploadFail (status, field) {
    }
  }
}
</script>

<style scoped>
  .change-avatar {
    align-content: center;
    text-align: center;
    padding-top: 10vh;
    padding-bottom: 10vh;
  }
</style>
